import { render, staticRenderFns } from "./OfferWrap.vue?vue&type=template&id=c257d53c&scoped=true&"
import script from "./OfferWrap.vue?vue&type=script&lang=js&"
export * from "./OfferWrap.vue?vue&type=script&lang=js&"
import style0 from "./OfferWrap.vue?vue&type=style&index=0&lang=less&"
import style1 from "./OfferWrap.vue?vue&type=style&index=1&id=c257d53c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c257d53c",
  null
  
)

export default component.exports